import { spawn } from 'redux-saga/effects';

import { sagas as details } from './detailsModule';
import { sagas as updateOrCreate } from './updateOrCreateModule';

export default function* sagas() {
	yield spawn(details);
	yield spawn(updateOrCreate);
}
